export class SettlementService {
  constructor(settlementRepository) {
    this.settlementRepository = settlementRepository;
  }

  async getSummary(pharmacyId, startDate, endDate) {
    if (!pharmacyId) throw new Error('약국 ID가 필요합니다.');
    if (!startDate || !endDate) throw new Error('조회 기간이 필요합니다.');
    return await this.settlementRepository.getSummary(pharmacyId, startDate, endDate);
  }

  async getPgPayments(pharmacyId, startDate, endDate, params = {}) {
    if (!pharmacyId) throw new Error('약국 ID가 필요합니다.');
    if (!startDate || !endDate) throw new Error('조회 기간이 필요합니다.');
    return await this.settlementRepository.getPgPayments(pharmacyId, startDate, endDate, params);
  }

  async getPointTransactions(pharmacyId, startDate, endDate, params = {}) {
    if (!pharmacyId) throw new Error('약국 ID가 필요합니다.');
    if (!startDate || !endDate) throw new Error('조회 기간이 필요합니다.');
    return await this.settlementRepository.getPointTransactions(pharmacyId, startDate, endDate, params);
  }

  async getCouponUsages(pharmacyId, startDate, endDate, params = {}) {
    if (!pharmacyId) throw new Error('약국 ID가 필요합니다.');
    if (!startDate || !endDate) throw new Error('조회 기간이 필요합니다.');
    return await this.settlementRepository.getCouponUsages(pharmacyId, startDate, endDate, params);
  }

  async getDaily(month) {
    if (!month) throw new Error('조회 월이 필요합니다.');
    return await this.settlementRepository.getDaily(month);
  }

  async getPaypointKpi(month) {
    if (!month) throw new Error('조회 월이 필요합니다.');
    return await this.settlementRepository.getPaypointKpi(month);
  }
}
